/**
 * /dashboard/performance/goals/new — Create a goal (Phase 7.3a).
 *
 * Posts to POST /performance/goals (own path; the server derives
 * tenant/user). A new goal starts as a DRAFT.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/performance/goals/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { GoalForm } from "@/components/performance/goal-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/goals/new",
)({
  component: NewGoalRoute,
});

function NewGoalRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <PerformanceModuleShell
      title="New Goal"
      description="Create an objective. It starts as a draft — add key results, then activate it."
    >
      <PerformanceFeatureGate>
        <Card>
          <CardContent className="py-6">
            <GoalForm />
          </CardContent>
        </Card>
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
